import { possuiPapel } from '@/lib/auth/roles'

import type { NavItem, NavSection } from './navItems'

/** Seções com os itens que o usuário pode ver; seções vazias saem. */
export function secoesVisiveis(
  sections: NavSection[],
  papeis: readonly string[] | undefined,
): NavSection[] {
  return sections
    .map((section) => ({
      ...section,
      items: section.items.filter((item) => !item.roles || possuiPapel(papeis, item.roles)),
    }))
    .filter((section) => section.items.length > 0)
}

/**
 * Quanto do caminho atual o item cobre (comprimento do `to`), ou -1 se não cobre.
 * Ignora `end` de propósito: `/inventario/itens/123` pertence à seção do item
 * `/inventario`, mesmo que o link só acenda na rota exata. Rotas do app são
 * case-insensitive (`/rh/Colaboradores`).
 */
function cobertura(item: NavItem, pathname: string): number {
  const to = item.to.toLowerCase()
  const path = pathname.toLowerCase()
  if (to === '/') return path === '/' ? 1 : -1
  return path === to || path.startsWith(`${to}/`) ? to.length : -1
}

/** Id da seção (com título) que contém a rota atual — a que abre e fica destacada. */
export function secaoDaRota(sections: NavSection[], pathname: string): string | undefined {
  let melhor: { id: string; cobertura: number } | undefined
  for (const section of sections) {
    if (!section.title) continue
    for (const item of section.items) {
      const c = cobertura(item, pathname)
      if (c > (melhor?.cobertura ?? -1)) melhor = { id: section.id, cobertura: c }
    }
  }
  return melhor?.id
}
